import { render, staticRenderFns } from "./FaqPage.vue?vue&type=template&id=76e16115&scoped=true&"
import script from "./FaqPage.vue?vue&type=script&lang=js&"
export * from "./FaqPage.vue?vue&type=script&lang=js&"
import style0 from "./FaqPage.vue?vue&type=style&index=0&id=76e16115&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e16115",
  null
  
)

export default component.exports